import React, { useState } from 'react';
import { FaPlaneDeparture, FaPlane, FaDirections, FaBus, FaUtensils, FaHotel, FaShoppingBasket, FaLandmark, FaUsers, FaPassport, FaBookOpen, FaDrumstickBite, FaHandsHelping, FaCalculator, FaStore, FaGift, FaCalendarAlt, FaTshirt, FaMosque, FaHandshake, FaUserTag, FaCommentSlash, FaMountain, FaTree, FaCamera, FaUniversity, FaSmile, FaHeart, FaChild, FaGrinSquintTears, FaLightbulb, FaVolumeUp, FaDownload, FaInstagram, FaTelegram, FaWhatsapp, FaCompass, FaCommentDots, FaArrowRight, FaBath, FaSearch } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const categories = [
  { label: 'All', icon: null, key: 'all' },
  { label: '✈️ Travel', icon: <FaPlane />, key: 'travel' },
  { label: '🍽️ Food', icon: <FaUtensils />, key: 'food' },
  { label: '🏠 Stay', icon: <FaHotel />, key: 'stay' },
  { label: '🛍️ Shop', icon: <FaShoppingBasket />, key: 'shop' },
  { label: '🎉 Culture', icon: <FaLandmark />, key: 'culture' },
  { label: '👫 Social', icon: <FaUsers />, key: 'social' },
  { label: '💬 Phrases', icon: <FaBookOpen />, key: 'phrases' },
  { label: '🧭 Adventure', icon: <FaMountain />, key: 'adventure' },
];

const sections = [
  {
    key: 'travel',
    color: 'blue',
    icon: <FaPlane className="text-blue-600" />,
    title: '✈️ Travel Basics',
    items: [
      { icon: <FaPassport className="text-blue-500" />, text: 'Airport signs & vocabulary (passport, customs, baggage)' },
      { icon: <FaDirections className="text-blue-500" />, text: <>How to ask for directions: <span className="persian-text bg-gray-100 px-2 py-1 rounded">چطور می‌روم به...؟</span></> },
      { icon: <FaBus className="text-blue-500" />, text: 'Transportation (taxis, buses, trains, Snapp)' },
    ],
  },
  {
    key: 'food',
    color: 'amber',
    icon: <FaUtensils className="text-amber-600" />,
    title: '🍽️ Food & Dining',
    items: [
      { icon: <FaBookOpen className="text-amber-500" />, text: <>Ordering food: <span className="persian-text bg-gray-100 px-2 py-1 rounded">میتونم منو را ببینم؟</span></> },
      { icon: <FaDrumstickBite className="text-amber-500" />, text: 'Famous dishes (chelo kabab, ghormeh sabzi)' },
      { icon: <FaHandsHelping className="text-amber-500" />, text: 'Eating customs & ta\'arof (polite offering/declining)' },
    ],
  },
  {
    key: 'stay',
    color: 'emerald',
    icon: <FaHotel className="text-emerald-600" />,
    title: '🏠 Staying with Locals or Hotels',
    items: [
      { icon: <FaBookOpen className="text-emerald-500" />, text: 'Hotel-related vocabulary' },
      { icon: <FaUsers className="text-emerald-500" />, text: 'Talking with hosts (couchsurfing/family settings)' },
      { icon: <FaBath className="text-emerald-500" />, text: 'Bathroom & shower terms (often overlooked!)' },
    ],
  },
  {
    key: 'shop',
    color: 'purple',
    icon: <FaShoppingBasket className="text-purple-600" />,
    title: '🛍️ Shopping & Bazaars',
    items: [
      { icon: <FaCalculator className="text-purple-500" />, text: 'Numbers, prices, and bargaining expressions' },
      { icon: <FaStore className="text-purple-500" />, text: 'Types of shops (supermarkets vs. traditional)' },
      { icon: <FaGift className="text-purple-500" />, text: 'Asking for souvenirs, spices, saffron, carpets' },
    ],
  },
  {
    key: 'culture',
    color: 'rose',
    icon: <FaLandmark className="text-rose-600" />,
    title: '🎉 Cultural Experiences',
    items: [
      { icon: <FaCalendarAlt className="text-rose-500" />, text: 'Persian holidays: Nowruz, Yalda, Chaharshanbe Suri' },
      { icon: <FaTshirt className="text-rose-500" />, text: 'How to dress appropriately in different regions' },
      { icon: <FaMosque className="text-rose-500" />, text: 'Mosque etiquette: shoes, headscarves, prayers' },
    ],
  },
  {
    key: 'social',
    color: 'indigo',
    icon: <FaUsers className="text-indigo-600" />,
    title: '👫 Social Etiquette',
    items: [
      { icon: <FaHandshake className="text-indigo-500" />, text: 'Ta\'arof: understanding politeness vs. sincerity' },
      { icon: <FaUserTag className="text-indigo-500" />, text: 'Introducing yourself properly (first and last name)' },
      { icon: <FaCommentSlash className="text-indigo-500" />, text: 'What not to say (religion, politics, etc.)' },
    ],
  },
  {
    key: 'phrases',
    color: 'pink',
    icon: <FaBookOpen className="text-pink-600" />,
    title: '🎭 Emotional & Fun Phrases',
    items: [
      { icon: <FaHeart className="text-pink-500" />, text: 'How you feel (excited, tired, hungry)' },
      { icon: <FaChild className="text-pink-500" />, text: 'Talking to kids or making friends casually' },
      { icon: <FaGrinSquintTears className="text-pink-500" />, text: 'Humor, expressions, and slang' },
    ],
  },
  {
    key: 'adventure',
    color: 'teal',
    icon: <FaMountain className="text-teal-600" />,
    title: '🧭 Exploring & Adventure',
    items: [
      { icon: <FaTree className="text-teal-500" />, text: 'Nature vocabulary (mountains, rivers, desert)' },
      { icon: <FaCamera className="text-teal-500" />, text: 'Booking tours, riding camels, camping phrases' },
      { icon: <FaUniversity className="text-teal-500" />, text: 'Heritage sites like Persepolis or Yazd' },
    ],
  },
];

const PersianCompanionTraveller: React.FC = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [search, setSearch] = useState('');

  const filteredSections = sections.filter(section =>
    (activeCategory === 'all' || section.key === activeCategory) &&
    section.items.some(item =>
      item.text.toString().toLowerCase().includes(search.toLowerCase())
    )
  );

  return (
    <div className="bg-gray-50 min-h-screen" dir="ltr">
      {/* Navigation Header */}
      <nav className="bg-white shadow-sm py-4 px-6 flex items-center justify-between">
        <div className="flex items-center">
          <Link to="/travel-companion" className="text-indigo-700 font-bold text-lg hover:text-indigo-900 transition">
            Travel Companion
          </Link>
        </div>
      </nav>
      {/* Header */}
      <header className="bg-gradient-to-r from-indigo-500 via-blue-700 to-blue-900 text-white py-12 px-4 rounded-b-3xl">
        <div className="container mx-auto text-center">
          <div className="flex justify-center mb-4">
            <div className="bg-white/20 p-3 rounded-full backdrop-blur-sm">
              <FaPlaneDeparture className="text-3xl" />
            </div>
          </div>
          <h1 className="text-3xl md:text-5xl font-bold mb-2 text-white">Persian Travel Companion</h1>
          <p className="text-lg md:text-xl opacity-90 text-white">Your essential guide to navigating Iran with confidence</p>
          <div className="mt-6">
            <button className="bg-white text-indigo-700 font-semibold px-6 py-2 rounded-full shadow-lg hover:bg-gray-100 transition">
              <FaDownload className="inline mr-2" /> Download PDF Guide
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-8 -mt-10">
        {/* Search and Filter */}
        <div className="bg-white rounded-xl shadow-md p-6 mb-8 sticky top-2 z-10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="relative w-full md:w-2/3">
              <input
                type="text"
                placeholder="Search for phrases or topics..."
                className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                value={search}
                onChange={e => setSearch(e.target.value)}
              />
              <FaSearch className="absolute left-3 top-3.5 text-gray-400" />
            </div>
            <div className="w-full md:w-auto">
              <select
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                value={activeCategory}
                onChange={e => setActiveCategory(e.target.value)}
              >
                <option value="all">All Categories</option>
                <option value="travel">Travel Basics</option>
                <option value="food">Food & Dining</option>
                <option value="stay">Accommodation</option>
                <option value="shop">Shopping</option>
                <option value="culture">Culture</option>
                <option value="social">Social</option>
                <option value="phrases">Phrases</option>
                <option value="adventure">Adventure</option>
              </select>
            </div>
          </div>

          <div className="flex overflow-x-auto py-4 mt-4 gap-2 hide-scrollbar">
            {categories.map(cat => (
              <button
                key={cat.key}
                className={`tab-btn px-4 py-2 whitespace-nowrap rounded-full font-medium ${activeCategory === cat.key ? 'bg-indigo-100 text-indigo-700 tab-active' : 'hover:bg-gray-100'}`}
                onClick={() => setActiveCategory(cat.key)}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </div>

        {/* Sections Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" id="sections-container">
          {filteredSections.map(section => (
            <div key={section.key} className="section-card bg-white rounded-xl overflow-hidden" data-category={section.key}>
              <div className={`h-2 bg-${section.color}-500`}></div>
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div className={`bg-${section.color}-100 p-2 rounded-lg mr-3`}>{section.icon}</div>
                  <h2 className="text-xl font-bold text-gray-800">{section.title}</h2>
                </div>
                <ul className="space-y-3 text-black">
                  {section.items.map((item, idx) => (
                    <li key={idx} className="flex items-start">
                      {item.icon}
                      <span className="ml-2">{item.text}</span>
                    </li>
                  ))}
                </ul>
                <Link
                  to={`/${section.key}-guide`}
                  className={`mt-4 text-${section.color}-600 font-medium flex items-center hover:text-${section.color}-800`}
                >
                  Learn more <FaArrowRight className="ml-2" />
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* Phrase of the Day */}
        <div className="bg-gradient-to-r from-blue-500 to-indigo-600 rounded-xl shadow-lg p-6 mt-10 text-white">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-2xl font-bold text-white">🌟 Phrase of the Day</h2>
            <div className="bg-white/20 p-2 rounded-full">
              <FaLightbulb className="text-xl text-white" />
            </div>
          </div>
          <div className="text-center py-6">
            <p className="text-2xl mb-4 persian-text text-white">کمک می‌خواهم</p>
            <p className="text-xl text-white">"I need help"</p>
            <p className="mt-2 opacity-90 text-white">Pronunciation: "komak meekhaham"</p>
          </div>
          <div className="flex justify-center mt-4">
            <button className="bg-white text-indigo-700 font-semibold px-6 py-2 rounded-full shadow hover:bg-gray-100 transition flex items-center">
              <FaVolumeUp className="mr-2" /> Hear Pronunciation
            </button>
          </div>
        </div>

        {/* Download CTA */}
        <div className="bg-indigo-50 rounded-xl p-8 mt-10 text-center">
          <h3 className="text-2xl font-bold text-indigo-800 mb-2">Ready for Your Persian Adventure?</h3>
          <p className="text-indigo-700 mb-6">Download our complete phrasebook with audio pronunciations</p>
          <button className="bg-indigo-600 text-white font-semibold px-8 py-3 rounded-full shadow-lg hover:bg-indigo-700 transition flex items-center mx-auto">
            <FaDownload className="mr-2" /> Get Full Guide
          </button>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-10 mt-16">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-6 md:mb-0">
              <div className="flex items-center">
                <div className="bg-white/20 p-2 rounded-full mr-3">
                  <FaCompass className="text-xl text-white" />
                </div>
                <h3 className="text-xl font-bold text-white">Persian Travel Companion</h3>
              </div>
              <p className="mt-2 text-gray-300">Your guide to authentic Iranian experiences</p>
            </div>
            <div className="flex space-x-6">
              <a href="#" className="text-gray-300 hover:text-white transition">
                <FaInstagram className="text-xl" />
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition">
                <FaTelegram className="text-xl" />
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition">
                <FaWhatsapp className="text-xl" />
              </a>
            </div>
          </div>
          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-300">
            <p>© 2023 Persian Travel Companion. All rights reserved.</p>
          </div>
        </div>
      </footer>

      {/* Floating Action Button */}
      <button className="floating-action-btn fixed bottom-6 right-6 bg-indigo-600 text-white p-4 rounded-full shadow-xl hover:bg-indigo-700 transition z-50">
        <FaCommentDots className="text-2xl" />
      </button>
    </div>
  );
};

export default PersianCompanionTraveller; 